/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ event: NonNullable<unknown> }} Push_Score_BodyInputs */

const th_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`กำลังแข่งที่ ${i?.event}`)
};

const en_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live at ${i?.event}`)
};

const ja_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} で試合中`)
};

const zh_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 直播中`)
};

const es_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En directo en ${i?.event}`)
};

const pt_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ao vivo em ${i?.event}`)
};

const id_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Langsung di ${i?.event}`)
};

const fr_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En direct à ${i?.event}`)
};

const tl_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live sa ${i?.event}`)
};

const vi_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trực tiếp tại ${i?.event}`)
};

const ko_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 실시간`)
};

const de_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live bei ${i?.event}`)
};

const ru_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Прямой эфир на ${i?.event}`)
};

const tr_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} etkinliğinde canlı`)
};

const it_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In diretta a ${i?.event}`)
};

const pl_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Na żywo na ${i?.event}`)
};

const uk_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`У прямому ефірі на ${i?.event}`)
};

const hi_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} में लाइव`)
};

const ar_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مباشر في ${i?.event}`)
};

const ms_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Langsung di ${i?.event}`)
};

const bn_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}-এ সরাসরি`)
};

const zh_tw2_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 直播中`)
};

const zh_hk2_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 直播中`)
};

const ur_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} میں براہ راست`)
};

const fa_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`زنده در ${i?.event}`)
};

const sw_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moja kwa moja ${i?.event}`)
};

const nl_push_score_body = /** @type {(inputs: Push_Score_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live bij ${i?.event}`)
};

/**
* | output |
* | --- |
* | "Live at {event}" |
*
* @param {Push_Score_BodyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_score_body = /** @type {((inputs: Push_Score_BodyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Score_BodyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_score_body(inputs)
	if (locale === "ja") return ja_push_score_body(inputs)
	if (locale === "zh") return zh_push_score_body(inputs)
	if (locale === "es") return es_push_score_body(inputs)
	if (locale === "pt") return pt_push_score_body(inputs)
	if (locale === "id") return id_push_score_body(inputs)
	if (locale === "fr") return fr_push_score_body(inputs)
	if (locale === "tl") return tl_push_score_body(inputs)
	if (locale === "vi") return vi_push_score_body(inputs)
	if (locale === "ko") return ko_push_score_body(inputs)
	if (locale === "de") return de_push_score_body(inputs)
	if (locale === "ru") return ru_push_score_body(inputs)
	if (locale === "tr") return tr_push_score_body(inputs)
	if (locale === "it") return it_push_score_body(inputs)
	if (locale === "pl") return pl_push_score_body(inputs)
	if (locale === "uk") return uk_push_score_body(inputs)
	if (locale === "hi") return hi_push_score_body(inputs)
	if (locale === "ar") return ar_push_score_body(inputs)
	if (locale === "ms") return ms_push_score_body(inputs)
	if (locale === "bn") return bn_push_score_body(inputs)
	if (locale === "zh-TW") return zh_tw2_push_score_body(inputs)
	if (locale === "zh-HK") return zh_hk2_push_score_body(inputs)
	if (locale === "ur") return ur_push_score_body(inputs)
	if (locale === "fa") return fa_push_score_body(inputs)
	if (locale === "sw") return sw_push_score_body(inputs)
	if (locale === "nl") return nl_push_score_body(inputs)
	return en_push_score_body(inputs)
});